export class ShopsAmountOffer {
    static instances = {};

    constructor(params) {
        this.componentId = params.componentId;
        if (!this.componentId) {
            throw new Error('Необходимо передать componentId');
        }

        this.componentElement = BX(this.componentId);
        if (!this.componentElement) {
            throw new Error('Не удалось найти элемент компонента');
        }

        this.shops = null;
        this.currentOfferId = null;
        this.offersAmount = params.offersAmount;
        this.emptyAmountMessage = params?.emptyAmountMessage ?? 'Нет в наличии';

        this.init();
    }

    init() {
        const shopsElements = this.componentElement.querySelectorAll('[data-shop]');
        const shops = [];
        shopsElements.forEach((element) => {
            const id = parseInt(element.getAttribute('data-shop'));
            const amountElement = element.querySelector('[data-amount]');
            shops.push({
                id,
                element,
                amountElement,
            });
        });
        this.shops = shops;
    }

    setOffer(offerId) {
        this.currentOfferId = offerId;
        this.showCurrentOfferAmount();
    }

    showCurrentOfferAmount() {
        const offerId = this.currentOfferId;
        if (!offerId) {
            return;
        }

        const amountData = (this.offersAmount ?? {})[offerId];
        this.shops.forEach((item) => {
            if (!item.amountElement) {
                return;
            }
            const amountText = amountData?.hasOwnProperty(item.id) && amountData[item.id] > 0
                ? amountData[item.id]
                : this.emptyAmountMessage;
            item.amountElement.innerText = amountText;
        });
    }

    static getInstance(productId) {
        if (!this.instances[productId]) {
            // this.instances[productId] = new ShopsAmountOffer();
        }
        return this.instances[productId];
    }

    static createNewInstance(productId, params = null) {
        if (!productId) {
            throw new Error('Необходимо передать id товара');
        }

        if (this.instances[productId]) {
            throw new Error('ShopsAmountOffer для указанного id уже существует');
        }

        this.instances[productId] = new ShopsAmountOffer(params);
    }
}
